module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FAMILIES")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0004.jpg",
      "src": "images/e9781439632802_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CHRISTOPHER AND PAULINA WEIER FAMILY.")]), _vm._v(" The Weier family was well known in the township for their large family, their knowledge of farming, and their civic mindedness. They farmed their 230 acres of land. The family home, built in 1872, is still standing on Plumbrook Road, just north of where 17 Mile Road crosses today. This portrait, taken around 1902, includes the entire family. Christopher Weier and his wife, Paulina Reifter Weier, are surrounded by their children—Paulina, Charles, Minnie, Gustav, Bertha, Julius, William, John, Martha, Albert, George, Louis, Elsa, and Otto. (Photograph courtesy of Elmer Measel.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_net"
  }, [_c('div', {
    staticClass: "image_net",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0005.jpg",
      "src": "images/e9781439632802_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CATHERINE AND FRED HACKER WITH WILLIAM,")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("C.")])]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("1875.")]), _vm._v(" Baby William is the first of the couple’s 10 sons. By 1880, they were living in their family home on the corner of Mound and 16 Mile Roads with their first four sons and Fred’s parents. The Hackers were successful farmers, and their family name has spread throughout Macomb County. The family home on Mound Road north of the Detroit News")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("North Plant was demolished in 2004 to make way for commercial development.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CATHERINE BAUER HACKER.")]), _vm._v(" This 1915 studio portrait shows the calm strength Catherine Hacker must have had to raise her sons on her own after the death of her husband, Frederick, in 1892, with the youngest less than a month old. Catherine was born in Detroit and came to Sterling Township upon her marriage. She died in 1920 at the age of 65, an admired woman. (Photograph courtesy of Rose Bower Hacker.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0006.jpg",
      "src": "images/e9781439632802_i0006.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0007.jpg",
      "src": "images/e9781439632802_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MOTHER AND SONS.")]), _vm._v(" In 1918, Catherine Hacker proudly poses with her sons, all grown into fine men. Pictured from left to right are (first row) Emil (farmer), William (Mount Clemens postmaster), Catherine, Albert (farmer and thresher man, lost a hand in a corn husker), and Otto (farmer); (second row) Christian (farmer with a small sawmill on 16 Mile Road), George (farmer), Charles (delivered mail out of the Utica Post Office for 30 years), Louis (Detroit police officer), Fred (tile contractor and farmer), and Benjamin (the youngest, 19 days old when his father died). According to an obituary in the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Utica Sentinel")]), _vm._v(", the sons used a variety of spellings of their family name, including Hacker, Haecker, Hecker. They were raised in a home at the northeast corner of 16 Mile and Mound Roads, which was demolished in 2005 to make way for a bank. Most of the sons stayed in Sterling Township, although a few spread out to Warren, Detroit, Mount Clemens, and Utica. (Photograph courtesy of Rose Bower Hacker.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_net"
  }, [_c('div', {
    staticClass: "image_net",
    staticStyle: {
      "width": "34%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0008.jpg",
      "src": "images/e9781439632802_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LOUIS HACKER.")]), _vm._v(" The fifth of the 10 sons of Sterling Township farmers Fred and Catherine Hacker, Louis must have decided to strike out on his own, leave the farm, and go to Detroit. The 1910 census shows him as a 28-year-old patrolman for the police department in Detroit, where he lived with his wife, Louise, and son Arthur, who was born a few years later. This portrait of Louis, looking quite dapper in his uniform, was probably taken about this time. (Photograph courtesy of Rose Bower Hacker.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0009.jpg",
      "src": "images/e9781439632802_i0009.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HACKER FAMILY REUNION.")]), _vm._v(" Widowed matriarch Catherine Hacker (striped dress) is seated in the center of this large group of family members gathered at Catherine’s home on the northeast corner of Mound and 16 Mile Roads in 1918. Included in the group are her 10 adult sons and their wives and children. (Photograph courtesy of Rose Bower Hacker.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0010.jpg",
      "src": "images/e9781439632802_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("OUT FOR A RIDE.")]), _vm._v(" Pictured about the time of their wedding, Edwin Haff and his bride, Adella Behrendt, go for a buggy ride in 1913. The couple lived with Edwin’s widowed father, Lorenzo, on the Haff farm on Dequindre Road, where they raised their five children—Vera, Gladys, Lawrence, Violet, and Ilene. The Haffs were “general farmers,” and Lawrence represents the fifth generation of Haffs on that farm. (Photograph courtesy of Lawrence Haff.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0011.jpg",
      "src": "images/e9781439632802_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HAFF FAMILY.")]), _vm._v(" In this March 1913 photograph, Edwin and Adella Haff (right), married for four days, pose with Edwin’s widowed father, Lorenzo Haff, and Lorenzo’s sister Phoebe Haff Johnson. The house behind them was awaiting partial demolition so that the left wing could be remodeled. Lorenzo’s grandfather Jacob Haff bought the property in 1839. The farm is located on Dequindre Road, south of Hall Road. The remodeled version of this house still stands, owned by Edwin and Adella’s son Lawrence Haff. (Photograph courtesy of Lawrence Haff.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "36%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0012.jpg",
      "src": "images/e9781439632802_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CYRUS S. SCHOONOVER.")]), _vm._v(" Sterling Township pioneer Cyrus S. Schoonover is pictured in a portrait taken around 1870 by the Novess Studio in Mount Clemens. Born in New York, he came to Sterling Township in 1847 with his first wife and their children—Phoebe, James, Lorenzo, and Mary. They settled on the northeast corner of 19 Mile and Ryan Roads. After the death of his wife, he married Elizabeth Donittey Wood, a widow from the area with five children. He and Elizabeth had three more children together, John, Cyrus A., and Fred. She brought to the marriage a farm south of 19 Mile Road on Ryan Road, which stayed in the family for three more generations. (Photograph courtesy of Ferry G. Schoonover.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ELIZABETH DONITTEY WOOD SCHOONOVER.")]), _vm._v(" Elizabeth was the second wife of Cyrus S. Schoonover, marrying him in 1852 after the death of her first husband, John A. Wood. The 1850 census shows her with John and six children—Ann, Sarah, Silas, William, Margaret, and Catherine. Her marriage to Cyrus Schoonover produced three children—John, Cyrus A., and Fred. Elizabeth lived to be 87 years old. (Photograph courtesy of Ferry G. Schoonover.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0013.jpg",
      "src": "images/e9781439632802_i0013.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LORENZO SCHOONOVER.")]), _vm._v(" Lorenzo, son of Cyrus S. Schoonover and Cyrus’s first wife, Mary, left the family farm on Ryan Road and 19 Mile Road in 1863 to follow his brother James and volunteer to fight in the Civil War. Lorenzo was with the 8th Michigan Cavalry and was taken prisoner in Georgia in August 1864. He spent about three months in the infamous Andersonville prisoner of war camp, returning home to his wife and child in 1865. His family continued to grow after his return, but they lost him again upon his death at the age of 34. This "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1880 portrait was taken by the H. M. Kittle studio in Pontiac, Michigan. (Photograph courtesy of Ferry G. Schoonover.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0014.jpg",
      "src": "images/e9781439632802_i0014.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0015.jpg",
      "src": "images/e9781439632802_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GENERATIONS.")]), _vm._v(" The family of Eliza Lovell (in bed) was able to gather and get this portrait taken during the last year of her life, around 1923. Included are her daughter Lydia Jane Lovell Schoonover (seated), Lydia Jane’s daughter Lima Schoonover King (standing left), Lima’s daughter Blanche King Hackett (standing right), and Blanche’s baby David Hackett. The Schoonover family was from the 19 Mile and Ryan Roads area, spreading over into Troy. (Photograph courtesy of Ferry G. Schoonover.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0016.jpg",
      "src": "images/e9781439632802_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CYRUS AND LYDIA SCHOONOVER FAMILY.")]), _vm._v(" Pictured in a portrait taken "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1891 by the Novess Studio in Mount Clemens is the family of Cyrus Alfred Schoonover and his wife, Lydia Jane Lovell Schoonover. The children are, from left to right, Lima (King), Carl E., Clyde, and Ira Frank. Tragedy struck the young family in the summer of 1900, when lightning struck their barn while family members were milking cows inside. Cyrus was killed instantly, and son Carl and a neighbor were also struck. Two barns, their contents (hay and wheat), and their older home all burned. The family continued bravely on, living on their Ryan Road farm for two more generations. Son Frank later became township treasurer. Cyrus was the son of Sterling Township pioneers Cyrus S. and Elizabeth Schoonover. (Photograph courtesy of Ferry G. Schoonover.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0017.jpg",
      "src": "images/e9781439632802_i0017.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CARL AND HILDA SCHOONOVER FAMILY.")]), _vm._v(" The Schoonover generations continue with the family of Carl E. Schoonover and his wife, Hilda Houghton Schoonover. They and their nine children stand in front of the family home, built in 1900 on Ryan Road south of 19 Mile Road. Pictured in 1941 are, from left to right, the following: (first row) Alger and twins Wilbert and Gilbert; (second row) Carl E. (father), Beatrice, Hilda (mother), Alfred, and Carl; (third row) Ferry, William, and Donald. Carl (senior), the son of Cyrus A. and Lydia Jane Schoonover, served on the war board for Sterling Township, and a number of his sons served in the armed forces during World War II. (Photograph courtesy of Ferry G. Schoonover.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0018.jpg",
      "src": "images/e9781439632802_i0018.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("GRATOPP FAMILY REUNION.")]), _vm._v(" Tossing their hats on the lawn, the Gratopp family and a family dog pose on a sunny day around 1920. The couple second from the left may be Christopher and Katherine Gratopp. Former neighbors had described them as “great people, very smart about farming. Christopher was a great, big man, 6’6”, with a handlebar mustache.” His wife, standing in front, was a “lovely darling little lady, not 5 feet tall.” The family farm, on Plumbrook Road (or Goose Road, as it was called back then) and 17 Mile Road, still stands. (Photograph courtesy of Lois Fischer Stone.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "47%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0019.jpg",
      "src": "images/e9781439632802_i0019.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SARAH AND WILLIAM UPTON WITH GIRLS.")]), _vm._v(" William Upton came from a successful farming family from the area, having been born in England and moving to Sterling Township in 1845 as a young child. He became even more prosperous due to his success at farming and business, and built the grandest home in the township, known as the Upton House, in 1866. In this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1920 photograph, William Upton sits with his wife, Sarah Aldrich Upton, great-granddaughter Marjorie Upton Sayre (DeFrancis), left, and another little girl. Little Marjorie is the daughter of his grandaughter Sarah. The Uptons were probably living at their later home in Rochester at the time of this photograph. (Photograph courtesy of Marjorie Upton DeFrancis.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("RENA UPTON.")]), _vm._v(" Young Rena Upton, the only daughter of prominent farmer William Upton and his wife, Sarah, died when she was only 11 years old from an illness related to her spine. She may have already been ill when this portrait was taken around 1879, not long before her death. Back in the earlier days of photography, portraits were often taken of the sick, even of the dead, if no portrait already existed. The family lived in the grand Upton House, on the corner of Utica Road and Dodge Park Road. (Photograph courtesy of Marjorie Upton DeFrancis.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0020.jpg",
      "src": "images/e9781439632802_i0020.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0021.jpg",
      "src": "images/e9781439632802_i0021.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE FRANK UPTON FAMILY.")]), _vm._v(" Frank Upton was the second son of prosperous farmer William Upton. Frank was born and raised in the Upton House, which still graces the corner of Utica and Dodge Park Roads. This "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1898 portrait shows him and his wife, Alice Fox Upton, and their only child, Sarah Jeanette Upton. By 1910, the family was living in Washington Township, where Frank and Alice lived out the rest of their lives. Daughter Sarah lived only to the age of 38, but her childhood likeness is immortalized in a statue currently in front of the Upton House, depicting her and her grandmother, Sarah Aldrich Upton, doing needlework. (Photograph courtesy of Marjorie Upton DeFrancis.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0022.jpg",
      "src": "images/e9781439632802_i0022.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SUMMER GATHERING.")]), _vm._v(" The William and Sarah Upton family is shown on a summer afternoon around 1915. The couple lived in Rochester, Michigan, at this time. From left to right are the following: (first row) Sarah Jeanette Upton, William Upton, and granddaughter Sarah Upton Sayre; (second row) daughter-in-law Alice Fox Upton, unidentified, and Oren Sayre. (Photograph courtesy of Marjorie Upton Sayre DeFrancis.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "51%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0023.jpg",
      "src": "images/e9781439632802_i0023.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WILLIAM AND SARAH UPTON.")]), _vm._v(" William and Sarah “Nettie” Upton are pictured here in their later years around 1915. By this time, the Uptons were probably living in Rochester, Michigan. After moving from the Upton House on Dodge Park Road to live in Utica in 1891, William ran a clothing and dry goods store in Utica called Upton and St. John. The store was located on the corner of Cass and Main Streets. He and his partner were also dealers in Shropshire sheep. The business was sold in 1897, and William became a general manager of a branch of the Salvation Army. The disastrous Utica fire of 1904 put him in a coma for a week after he fell from the roof of his commercial building he was trying to protect. He survived, but the building did not. The Uptons moved to Rochester not long after, and William died in 1923. Sarah lived until 1925. (Photograph courtesy of Marjorie Upton Sayre DeFrancis.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0024.jpg",
      "src": "images/e9781439632802_i0024.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE MAROTZ FAMILY.")]), _vm._v(" The Marotz homestead stood on Clinton River Road south of 19 Mile Road. This house was replaced by another one farther back off the road in 1915. Wood from this original house was used to build the garage for the newer home. The family in this view from around 1901 includes, from left to right, aunt Lena Fischer, Tillie, Wilhelmina Fischer Marotz (mother), Lillian, August Jr., August Sr. (father), and Otto. Various animals are shown in the arms of the children. Siblings Tillie, Lena, and Otto never married and continued to live out the rest of their long lives on this farm, selling corn and other vegetables they grew to appreciative suburbanites, even into the 1980s.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0025.jpg",
      "src": "images/e9781439632802_i0025.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AUGUST AND WILHELMINA MAROTZ.")]), _vm._v(" Young August came to America as a teenager from Prussia, otherwise known as Germany, in 1883. He married Wilhelmina Fischer in 1890 and moved to a farm on Clinton River Road south of 19 Mile Road, neighboring his brother’s farm. August and “Minnie,” pictured here around 1945, raised five children there while doing general farming.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "61%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0026.jpg",
      "src": "images/e9781439632802_i0026.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRED AND AUGUSTA HELDT.")]), _vm._v(" Fred was the son of Charles and Anna Heldt, early pioneers who came from Germany and who had a farm on 15 Mile Road west of Hayes since at least the 1870s. Pictured around 1915 are Fred and his wife, Augusta Wade Heldt. They lived on that same Heldt farm on 15 Mile Road most of their lives and raised eight children there—William, John, Albert, Louis, Amanda, Rudolph, Minnie, and Paulina. In their later years, they lived in the home known as the William Upton House on Dodge Park Road with some of their younger children. The Heldts lived and farmed there from 1913 to 1927. Fred conveyed part of the property across the road to the State of Michigan in 1922 to create Dodge Park. The park became wildly popular with people from the Detroit area, as there were few other state parks within driving distance, and today it is part of the city park system.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LOUIS HELDT.")]), _vm._v(" The fourth son of Fred and Augusta Heldt, Louis is shown seated at an organ around 1915. His parents lived in the Upton House at the time, so this may be one of the few interior views of the elegant home if he was indeed living with them at the time. Louis married a woman named Martha and had children Edna, Bernice, Elmer, and Howard. He lived in Detroit for the rest of his life.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0027.jpg",
      "src": "images/e9781439632802_i0027.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0028.jpg",
      "src": "images/e9781439632802_i0028.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE HOLZHAUER FAMILY.")]), _vm._v(" The Holzhauer family enjoys a summer day by looking through photographs. The family home was on Utica Road, west of Kleino Road, where they grew flowers and bulbs to sell in Mount Clemens and from their roadside stand. Pictured in this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1940 photograph are, from left to right, the following: (seated) Fred Holzhauer and his wife, Anna; (standing) son Carl, daughter Irene, and Carl’s wife, Edith. (Photograph courtesy of Irene Holzhauer Hoffman.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0029.jpg",
      "src": "images/e9781439632802_i0029.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CHARLES AND LOUISE AHRENS FAMILY.")]), _vm._v(" The Ahrens farm, located on Clinton River Road just west of Hayes Road, provided the backdrop for this photograph, taken around 1905. The family includes, from left to right, Carl, infant Meta (being held by her mother, Louise Arft Ahrens), Charles Ahrens, Albert, Mary Arft, Martha, and Otto. Mary Arft was the mother of Louise. It was common for elderly parents, especially when widowed, to move in with their children. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "34%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0030.jpg",
      "src": "images/e9781439632802_i0030.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MARTHA AND OTTO.")]), _vm._v(" The two oldest children of Charles and Louise Ahrens of Clinton River Road are captured in this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1892 portrait, taken by the Novess Studio in Mount Clemens. Martha Ahrens (Sieger) and her little brother Otto look very cute and sit still very nicely. (Photograph courtesy of Eleanor Ahrens.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AHRENS FAMILY PORTRAIT.")]), _vm._v(" The Novess Studio in Mount Clemens was the photographer for this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1900 portrait of Charles and Louise Ahrens (seated) and family. The children are, from left to right, Otto, his younger brother Carl, and their older sister Martha. Children Albert and Meta were yet to be born. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0031.jpg",
      "src": "images/e9781439632802_i0031.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0032.jpg",
      "src": "images/e9781439632802_i0032.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BROTHERS.")]), _vm._v(" Otto Ahrens (seated) and his younger brother Carl (standing) pose for this casual "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1910 portrait. For a time, during his earlier teen years, Otto worked as a live-in servant for his uncle Frederick Ahrens in the Upton House, which the uncle and his family owned and lived in from approximately 1891 to 1913, following the Uptons. Otto and Carl were the second–and third-born children of Charles and Louise Ahrens of Clinton River Road. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0033.jpg",
      "src": "images/e9781439632802_i0033.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FOERSTER-AHRENS WEDDING.")]), _vm._v(" Looking very handsome in their wedding finery, Ella Foerster, of Warren, and Carl Ahrens, of Sterling Township, pose around 1915. Ella was the daughter of John and Barbara Foerster, and Carl was the son of Charles and Louise Ahrens. The couple became the parents of Veola Ahrens. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0034.jpg",
      "src": "images/e9781439632802_i0034.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FOUR GENERATIONS, AHRENS")]), _vm._v("-"), _c('strong', {
    staticClass: "b"
  }, [_vm._v("KLEINO.")]), _vm._v(" Proud great-grandparents Charles and Louise Ahrens hold their great-grandchildren Audrey and Duane in this 1938 photograph. Behind them are, from left to right, their daughter Martha Ahrens Sieger, her husband Arthur Sieger, the Siegers’ daughter Hulda Sieger Kleino, and her husband Melvin Kleino. Hulda and Melvin are the parents of the small children. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ELEANOR’S CONFIRMATION.")]), _vm._v(" This studio portrait by Sawn Studio of Mount Clemens commemorates young Eleanor Ahrens’s confirmation at St. Paul Lutheran Church around 1936. The confirmation ceremony signaled the entrance into adulthood for young Lutherans. Eleanor and her two older sisters grew up working on the family farm. She and her sisters collected stray golf balls that landed on their property from Rammler Golf Course and used the proceeds to help pay their tuition to Utica High School. Eleanor was the daughter of Otto and Eleanor Ahrens of Clinton River Road. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0035.jpg",
      "src": "images/e9781439632802_i0035.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0036.jpg",
      "src": "images/e9781439632802_i0036.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("AHRENS SIBLINGS AND SPOUSES.")]), _vm._v(" At this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1961 gathering, the five children of Charles and Louise Ahrens of Sterling Township pose with their spouses. The husbands are standing behind their wives. From left to right are the following: (first row) Rose Lietz Ahrens, Ella Foerster Ahrens, Eleanor Zienert Ahrens, Martha Ahrens Sieger, and Meta Ahrens Schmelzer; (second row) Albert Ahrens, Carl Ahrens, Otto Ahrens, Arthur Sieger, and John Schmelzer. In 2005, Meta celebrated her 101st birthday before she passed away. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0037.jpg",
      "src": "images/e9781439632802_i0037.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHRISTOPHER KLEINO.")]), _vm._v(" Born in Mecklenburg, Germany, in 1831, Christopher Kleino (shown around 1890) came to America in 1862 with his new bride, Mary Harloff. The 1880 census shows that the family settled on Utica Road where the Kleino Bridge used to cross the Clinton River. The bridge, until late in the 20th century, was the only place to cross the river in the township. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MARY HARLOFF KLEINO.")]), _vm._v(" Mary Kleino, the newly married wife of Christopher Kleino, came with him from Germany to raise their family on a farm on Utica Road. Their six children were Henrietta, Louisa, Mary, Charles, Louis, and Fred. Mary is pictured here around 1890 in a portrait taken by the Novess Studio in Mount Clemens. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0038.jpg",
      "src": "images/e9781439632802_i0038.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE REWOLDT-KLEINO WEDDING.")]), _vm._v(" This handsome couple poses for their wedding portrait at Huntington and Company photographers in Detroit, Michigan, around 1902. Martha Rewoldt of Waldenberg, Michigan, and Louis Kleino of Sterling Township, raised their children Elmer, Edgar, Melvin, Marion, and Norma on their Kleino Road farm. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0039.jpg",
      "src": "images/e9781439632802_i0039.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0040.jpg",
      "src": "images/e9781439632802_i0040.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MARTHA AND LOUIS KLEINO CELEBRATE 20 YEARS.")]), _vm._v(" This photograph was taken around 1922 in honor of the 20th wedding anniversary of the couple. Louis was a prominent farmer and official of Utica and Sterling Township. He had been township clerk, health officer, and official of the Maple Grove school board for many years. He was also one of the founders of the Utica Farm Bureau. Together the couple raised five children. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0041.jpg",
      "src": "images/e9781439632802_i0041.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SIEGER-KLEINO WEDDING.")]), _vm._v(" St. John Lutheran Church in Fraser was the site of the 1935 wedding of Hulda Sieger and Melvin Kleino. Hulda was the daughter of Arthur Sieger and Martha Ahrens Sieger, and Melvin was the son of Louis Kleino and Martha Rewoldt Kleino of Sterling Township. The newlyweds resided at the Kleino farm on Kleino and Utica Roads in Sterling Township. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0042.jpg",
      "src": "images/e9781439632802_i0042.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE LOUIS AND MARTHA KLEINO FAMILY.")]), _vm._v(" Here Louis and Martha Kleino pose with their grown children on a summer day around 1938. Pictured from left to right are Louis Kleino, Martha Rewoldt Kleino, Elmor Kleino, Edgar Kleino, Melvin Kleino, Marion Kleino Reindel, and Norma Kleino (Schurig). (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("KLEINO CHILDREN WITH MOM.")]), _vm._v(" Hulda Sieger Kleino holds Lonnie while Duane and his big sister, Audrey, share a bench next to the Kleino home on Kleino Road in this photograph from around 1942. These children were the fourth generation of Kleinos to live on this farm. Their father was Melvin Kleino. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "42%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0043.jpg",
      "src": "images/e9781439632802_i0043.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "39%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0044.jpg",
      "src": "images/e9781439632802_i0044.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE JOHN AND LOUISE ARFT WEDDING.")]), _vm._v(" John, the son of Sterling Township farmers John and Mary Arft, is shown here in a Novess Studio portrait upon his wedding to Louise in 1898. The Arft family came from Germany in 1840 and settled on Clinton River Road. After John and Louise’s marriage, they lived for a few years with his parents. They then moved to Pontiac, Michigan, and raised their children Carl, Clarence, Harold, and Linda. John worked as a carpenter in the auto plants and later worked in the home-building trades. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0045.jpg",
      "src": "images/e9781439632802_i0045.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE ARFT-SCHULDT WEDDING.")]), _vm._v(" Minnie Arft and Charles M. Schuldt are seen in this wedding portrait taken at the Baron Studio on Monroe Avenue in Detroit in November 1897. Charles came to America as a young boy from Prussia (Germany), and Minnie may have come from the Arft family of Warren, Michigan. The couple had a dairy farm on Clinton River Road, south of 19 Mile Road, and raised three children there. (Photograph courtesy of Armin “Duane” Kleino.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("BABY ALBERT SCHULDT.")]), _vm._v(" Albert Schuldt was the first child of Minnie and Charles Schuldt of Clinton River Road. Here, he has his portrait taken in Rochester, Michigan by E. N. Auten, photographer, around 1899, coinciding with the short time the young family was farming in Avon Township. Young Albert wears a dress for this portrait, as was the custom at the time. Very young children, whether a boy or a girl, usually wore a dress-type garment. (Photograph courtesy of Armin “Duane” Kleino.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0046.jpg",
      "src": "images/e9781439632802_i0046.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0047.jpg",
      "src": "images/e9781439632802_i0047.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE SCHULDT FAMILY.")]), _vm._v(" The family of Charles and Minnie Schuldt poses around 1920. From left to right are Meta Schuldt (Schoenberg), Minnie Arft Schuldt, Lenora Schuldt (Witt), Charles Schuldt, and Albert Schuldt. Note the early automobiles parked nearby.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRED AND FRIEDERICKA KARR.")]), _vm._v(" After Friedericka’s first husband, John Doebler, died, leaving her with two small children, August and baby John, she married neighbor Fred Karr. Two more children, Bertha and Louise, had been born by 1869, when they left Germany and came to America and settled in the Schoenherr and Hall Road area of Sterling Township. By 1885, they had built a log cabin home on 19 Mile Road. This portrait of the couple was taken by the Novess Studio in Mount Clemens around 1890. (Photograph courtesy of Wallace Doebler.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0048.jpg",
      "src": "images/e9781439632802_i0048.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "38%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0049.jpg",
      "src": "images/e9781439632802_i0049.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JOHN AND MARTHA DOEBLER.")]), _vm._v(" The Novess Studio in Mount Clemens takes the credit for yet another portrait of Sterling Township residents, this one around 1890. Pictured are John Doebler and his wife, Martha Schulz Doebler. Both born in Germany, they met in Michigan, married, and raised their family on a 40-acre Canal Road farm, later increased to almost 100 acres. Their children were Agnes, Ada, Herbert, and Reno. Sadly, baby Reno lived only a few months. The Doeblers were very successful general farmers, having a route in Detroit to sell their excess cabbage, potatoes, eggs, and chickens. (Photograph courtesy of Wallace Doebler.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0050.jpg",
      "src": "images/e9781439632802_i0050.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE DOEBLER AND SCHULZ FAMILIES.")]), _vm._v(" A wooden swing in the front yard of the Doebler home on Canal Road provides the gathering point for this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1904 photograph of the Doebler and Schulz families. From left to right are the following: (first row) Herbert Doebler, Roland Schulz, Edgar Schulz, Arthur Schulz, and Bernice Schulz; (second row) Martha Doebler, Alma Schulz, Carl Daus, Alice Schulz, John Doebler, Fredericka Karr, unidentified, unidentified, Elda Schulz, and Anna Schulz. (Photograph courtesy of Wallace Doebler.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0051.jpg",
      "src": "images/e9781439632802_i0051.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FRANK AND FRIEDRICKA SCHULZ.")]), _vm._v(" Ferdinand (Frank) Schulz and Friedricka (Ricky) Lehman Schulz leave St. Paul Lutheran Church in a buggy after having had a ceremony honoring their 50th wedding anniversary, a rarity for a married couple to both live that long. They were born and married in Germany and moved into a log cabin on Schoenherr Road north of Canal Road in 1879, where they raised six children. The anniversary celebration occurred in 1910, and the church was filled with family and friends. (Photograph courtesy of Wallace Doebler.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0052.jpg",
      "src": "images/e9781439632802_i0052.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ANNIVERSARY PARTY.")]), _vm._v(" The family gathers at the Schulz home to continue the party honoring Frank and Ricky Schulz on their 50th wedding anniversary. This house, as pictured in 1910, was built in the 1880s on Canal Road east of Saal Road. The front part was a store, and the back had a blacksmith shop. Ricky, pictured wearing a wedding wreath, and Frank, with a white beard, enjoy the gathering that included a chicken dinner with all the trimmings, and a shivaree, complete with dynamite and beer. A good time was had by all. (Photograph courtesy of Wallace Doebler.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0053.jpg",
      "src": "images/e9781439632802_i0053.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SNOWY DAY AT THE FAUST LOG CABIN.")]), _vm._v(" William W. Faust, son of Charles and Sophie Faust, poses with his dog at the front door to the family log cabin around 1900. The home, located on 19 Mile Road west of Schoenherr Road, was built in 1873 by his father, Charles Faust. The home still stands and is located in front of Browning Elementary School.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0054.jpg",
      "src": "images/e9781439632802_i0054.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MAN’S BEST FRIEND.")]), _vm._v(" Pictured around 1910 are Albert “Mike” Faust and his dog Shep, comfortably seated in their farmyard on 19 Mile Road east of Clinton River Road. Mike never married and lived on the farm alone for about 30 years. Notice the buggy in the background, waiting for the Saturday night trip into town, and the cigar in Mike’s hand, a common accessory for German farmers. (Photograph courtesy of Barbara Faust Counsell.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0055.jpg",
      "src": "images/e9781439632802_i0055.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("WILLIAM AND BERTHA LIEBERENZ.")]), _vm._v(" The Lieberenz 80-acre farm was on the southwest corner of 17 Mile Road and Van Dyke, sharing the property with the Plumbrook School, for which the family donated land. William and Bertha Beier Lieberenz had three children and did a little bit of everything. They were both very active in the community, William being township supervisor, township clerk, and an officer for the Sterling School District No. 2. He was a very “modern” farmer, attended the Detroit Business Institute, and always liked to have the newest, most modern conveniences. Their large home on Van Dyke was very up to date. In this 1927 photograph, the couple stands in their front yard, with Van Dyke Avenue behind them.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0056.jpg",
      "src": "images/e9781439632802_i0056.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PHILLIP BOWER.")]), _vm._v(" Phillip Bower, his wife Catherine, and their two small sons, George and Lenhart (or Leonard), came from Prussia around 1859, living in Warren Township for a time before settling in Sterling Township on a farm on 16 Mile Road between Mound and Ryan Roads. The family built a log cabin there, and by 1875 another, more permanent home was added. That home still stands. The couple raised an additional seven children on their family farm: Frederick, Michael, Lizzie, Charles, John, Lambert, and Mary. This portrait, by a Mount Clemens photographer, was probably taken about 1880.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CATHERINE SCHUMMEL BOWER.")]), _vm._v(" Married to Phillip Bower, Catherine came with her husband from Prussia with an apparent stay in Canada for a few years before eventually settling in Sterling Township on 16 Mile Road, where they raised nine children. This "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1880 portrait was taken by Eisenhardt at his Detroit studio. (Photograph courtesy of Rose Bower Hacker.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0057.jpg",
      "src": "images/e9781439632802_i0057.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "63%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0058.jpg",
      "src": "images/e9781439632802_i0058.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ROSE BOWER HACKER.")]), _vm._v(" Rose Hacker was born on the farm of her father, Michael Bower, on the northwest corner of 17 Mile and Mound Roads. Her mother died when she was three. Later, she attended the Plumbrook School. She met and married Christopher Hacker (the 8th of the 10 Hacker boys) and bought the 1875 house built by her grandfather, Phillip Bower, on 16 Mile Road between Mound and Ryan Roads. There she raised their three children—Marvin, Norma, and Shirley. At the age of 92, Rose became well known when the 1986 widening of 16 Mile Road threatened the old farmhouse she still lived in. She and community activists were finally able to get permission to save the house by moving it to a nearby subdivision, where it still stands today. (Photograph courtesy of Rose Bower Hacker.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0059.jpg",
      "src": "images/e9781439632802_i0059.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MICHAEL BOWER HOUSE.")]), _vm._v(" Michael Bower was the son of Phillip and Catherine Bower, whose farm was on 16 Mile Road. Michael and his first wife built this home on 17 Mile Road just west of Mound Road and were parents to Louis and Rose. Michael’s wife died, and he married Catherine, with whom he had three more children—Bertha, Albert, and Edwin. Pictured around 1910 are, from left to right, Bertha, Michael, Albert, Rose, Edwin, and Catherine. (Photograph courtesy of Rose Bower Hacker.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_net"
  }, [_c('div', {
    staticClass: "image_net",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0060.jpg",
      "src": "images/e9781439632802_i0060.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LOUISE AND WINFIELD DRAKE.")]), _vm._v(" Winfield Scott Drake was born in a log cabin on the Drake farm on Clinton River Road in 1849. His relatives have lived in the area since 1832. Winfield married Louisa (Louise) Stead, from another Sterling Township pioneer family, in 1874 and raised their family on the River Road near Kleino Road. This photograph of the couple was taken around 1900. Winfield held numerous township offices and was director of Sterling School No. 3 (Maple Grove). Winfield lived to be 92 years old and was buried with his wife at Edgerton Cemetery. (Photograph courtesy of Merle Drake Peters.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "53%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0061.jpg",
      "src": "images/e9781439632802_i0061.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE CALKA FAMILY.")]), _vm._v(" Andrew and Katherine Calka came from Poland and after some hard times eventually purchased a farm on Hayes Road in Clinton Township where St. Joseph Hospital is today. They raised five boys. Pictured "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c.")]), _vm._v(" 1944 are Andrew, Katherine, and their youngest son Bernard, or Barney. Barney and all his brothers were World War II veterans, Barney being an MP in the Philippines. Upon his return, he got married and had five children. Moving into Sterling Township, he started as a volunteer firefighter and ended up working for the department for 26 years, retiring as assistant fire chief in 1984. His lifetime volunteer efforts include creating the Michigan State Fireman’s Memorial in Roscommon, Michigan, raising money for underprivileged fire departments across the nation, and work with the Sterling Heights Lions Club. (Photograph courtesy of Bernard Calka.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0062.jpg",
      "src": "images/e9781439632802_i0062.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE BACKUS FAMILY.")]), _vm._v(" Shown around 1922 are the beginnings of the large Emin and Eva Backus family. From left to right are Josephine, Anthony, father Emin (holding Nellie), mother Eva (holding Marie), Agnes, and Madeline. More children were born later—Joseph, Catherine, Peter, Louis, Eva, Margaret, and Paul. Emin came from Lebanon in the early 1900s, operated a business in Detroit, and came to Sterling Township around 1945. The family had a small farm on 17 Mile Road west of Van Dyke Avenue and, in the 1960s, opened a car wash that still operates today. Joe and Paul Backus were on the township’s first volunteer fire department. Paul was one of the first four full-time paid men and retired years later as a captain. The Lebanese Backus family represented the first wave of Middle Eastern immigrants to contribute to the area. (Photograph courtesy of the Backus family.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WILBRETT FAMILY.")]), _vm._v(" Pictured around 1939 are, from left to right, Wilhelmina Juengel, her daughter Albertine Juengel Wilbrett, Myrna Kage (baby granddaughter of Albertine), and proud grandfather Albert Wilbrett. Albert had been a streetcar conductor in Detroit before coming to the southwest corner of Hall Road and Schoenherr Road to farm. He died in 1945 from an accidental fall from their hayloft. (Photograph courtesy of Cheryl Wilbrett Snay.)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "37%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0063.jpg",
      "src": "images/e9781439632802_i0063.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0064.jpg",
      "src": "images/e9781439632802_i0064.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE WILBRETT BOYS.")]), _vm._v(" Howard Wilbrett, his brother Arnold, Arnold’s son David, and a watchful canine friend pose out in the cornfield in this 1945 photograph. The Wilbretts also grew rhubarb, strawberries, greens, tomatoes, and melons on their farm at the corner of Hall and Schoenherr Roads. The corn must have been especially tasty that year. (Photograph courtesy of Cheryl Wilbrett Snay.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0065.jpg",
      "src": "images/e9781439632802_i0065.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("LITTLE MYRNA KAGE.")]), _vm._v(" Baby Myrna Kage, held securely by her uncle Arnold Wilbrett, poses for this 1939 photograph. Her father, Marvin Kage, watches from behind. The Kage and Wilbrett farms were neighbors on Hall Road, west of Schoenherr Road, and their land was later developed for the Clinton Valley Mall. (Photograph courtesy of Cheryl Wilbrett Snay.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0066.jpg",
      "src": "images/e9781439632802_i0066.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CONFIRMATION PARTY.")]), _vm._v(" A large buffet is set up in the dining room of the Wilbrett home on Hall Road to celebrate the 1957 confirmation of Marvin Kage Jr. and his cousin David Wilbrett. Confirmation was an important coming-of-age event in the Lutheran church, usually occurring when young people were about 14 years old. (Photograph courtesy of Cheryl Wilbrett Snay.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5358a00c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439632802_c01.vue
// module id = 78
// module chunks = 0